import {FirebaseMessagingTypes} from '@react-native-firebase/messaging';

export default (_: FirebaseMessagingTypes.RemoteMessage) => {
  console.error("It's a stub");
};

export const setBadgeCount = (_count: number) => {};
